import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from '../../../../../core/services/auth.service';
import { CarrierService } from '../../../home/services/carrier.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class CarrierProfileDataGuard  {
  constructor(
    private carrierService: CarrierService,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.carrierService.getCarrierProfile().pipe(
      catchError(() => {
        this.toastrService.error(
          this.translateService.instant('SHARED.FORBIDDEN-PAGE'),
        );
        this.router.navigate(['/']);
        return of(false);
      }),
      map((response: any) => {
        return true;
      }),
    );
  }
}
